// extracted by mini-css-extract-plugin
var _1 = "ra-quiz-question-active";
var _2 = "ra-quiz-question-button-back";
var _3 = "ra-quiz-question-button";
var _4 = "ra-quiz-question-button-next";
var _5 = "ra-quiz-question";
var _6 = "ra-quiz-question-overlay";
var _7 = "ra-quiz-question-text";
export { _1 as "quizQuestionActiveCls", _2 as "quizQuestionButtonBackCls", _3 as "quizQuestionButtonCls", _4 as "quizQuestionButtonNextCls", _5 as "quizQuestionCls", _6 as "quizQuestionOverlayCls", _7 as "quizQuestionTextCls" }
